// extracted by mini-css-extract-plugin
module.exports = {"first_name":"index-module__first_name___ahXIo","last_name":"index-module__last_name___LbTA9"};